import React, { useState } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Typography,
  Row,
  Col,
  message,
  InputNumber,
} from 'antd';
import emailjs from '@emailjs/browser';
import '../styles/PedidosOracion.css';

const { Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const PedidoDeOracion = () => {
  const [pedidoType, setPedidoType] = useState('texto');
  const [form] = Form.useForm(); // Create a Form instance

  const onFinish = (values) => {
    const templateParams = {
      nombres: values.nombres,
      apellidos: values.apellidos,
      edad: values.edad,
      telefono: values.telefono,
      pedido: pedidoType === 'texto' ? 'Texto Personalizado' : 'Categoría',
      textoPersonalizado:
        pedidoType === 'texto' ? values.textoPersonalizado : '',
      categoria: pedidoType === 'categoria' ? values.categoria : '',
      email: 'ivalomasdtafi@gmail.com',
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          message.success('Pedido de oración enviado con éxito.'); // Show success message
          form.resetFields(); // Clear the form inputs
        },
        (error) => {
          console.error('Error sending email:', error);
          message.error('Hubo un error al enviar el pedido de oración.'); // Show error message
        }
      );
  };

  const onFinishFailed = (errorInfo) => {
    console.error('Error en el formulario:', errorInfo);
    message.error('Por favor complete todos los campos correctamente.'); // Show error message for validation failure
  };

  return (
    <div
      style={{
        maxWidth: '600px',
        margin: '20px auto',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.4)',
        backgroundColor: '#fff',
      }}
    >
      <Title
        level={3}
        style={{
          textAlign: 'center',
          marginBottom: '20px',
          fontFamily: 'Outfit',
          fontSize: '35px',
        }}
      >
        Pedido de Oración
      </Title>
      <Form
        form={form} // Bind the Form instance
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Nombre/s"
              name="nombres"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese su(s) nombre(s)',
                },
                { max: 50, message: 'Máximo 3 nombres permitidos' },
                {
                  pattern: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,50}$/,
                  message:
                    'El nombre solo puede contener letras y hasta 3 espacios',
                },
              ]}
            >
              <Input placeholder="Ingrese su(s) nombre(s)" maxLength={50} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Apellido/s"
              name="apellidos"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese su(s) apellido(s)',
                },
                { max: 50, message: 'Máximo 2 apellidos permitidos' },
                {
                  pattern: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,50}$/,
                  message:
                    'El apellido solo puede contener letras y hasta 3 espacios',
                },
              ]}
            >
              <Input placeholder="Ingrese su(s) apellido(s)" maxLength={50} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Edad"
              name="edad"
              rules={[
                { required: true, message: 'Por favor ingrese su edad' },
                {
                  type: 'number',
                  min: 1,
                  max: 120,
                  message: 'La edad debe estar entre 1 y 120 años',
                },
              ]}
            >
              <InputNumber
                placeholder="Ingrese su edad"
                min={1}
                max={120}
                style={{ width: '100%' }} // Ensure it takes the full width
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Número de Teléfono"
              name="telefono"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese su número de teléfono',
                },
                {
                  pattern: /^[0-9]{10,15}$/,
                  message:
                    'Ingrese un número de teléfono válido (10-15 dígitos)',
                },
              ]}
            >
              <Input
                placeholder="Ingrese su número de teléfono"
                maxLength={15}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="Pedido de Oración"
          name="pedido"
          rules={[
            {
              required: true,
              message: 'Por favor seleccione o ingrese su pedido de oración',
            },
          ]}
        >
          <Select
            placeholder="Seleccione el tipo de pedido"
            onChange={(value) => setPedidoType(value)}
          >
            <Option value="texto">Texto Personalizado</Option>
            <Option value="categoria">Seleccionar Categoría</Option>
          </Select>
        </Form.Item>

        {pedidoType === 'texto' ? (
          <Form.Item
            label="Texto Personalizado"
            name="textoPersonalizado"
            rules={[
              {
                required: true,
                message: 'Por favor ingrese su pedido de oración',
              },
              { max: 300, message: 'Máximo 300 caracteres permitidos' },
            ]}
          >
            <TextArea
              placeholder="Ingrese su pedido de oración (máximo 300 caracteres)"
              maxLength={300}
              rows={4}
              style={{ resize: 'none' }}
            />
          </Form.Item>
        ) : (
          <Form.Item
            label="Categoría"
            name="categoria"
            rules={[
              { required: true, message: 'Por favor seleccione una categoría' },
            ]}
          >
            <Select placeholder="Seleccione una categoría">
              <Option value="salud">Salud</Option>
              <Option value="familia">Familia</Option>
              <Option value="trabajo">Trabajo</Option>
              <Option value="otros">Otros</Option>
            </Select>
          </Form.Item>
        )}

        <Row justify="center">
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="pedido-button"
              >
                Enviar Pedido
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default PedidoDeOracion;
